import { ProductCode } from "Infrastructure/Api/Api";

// Products onboarded through the shared Comgate contract and Switchio TMS. Orbit L ships physical
// terminals, SoftPOS runs on the merchant's phone; a merchant may hold either or both on one contract.
export const COMGATE_PRODUCT_CODES: ReadonlyArray<ProductCode> = [
  ProductCode.OrbitL,
  ProductCode.SoftPos,
];

export const isComgateProductCode = (code?: ProductCode | null) =>
  !!code && COMGATE_PRODUCT_CODES.includes(code);

export const PRODUCTS_REQUIRING_FACILITY = [
  ProductCode.OrbitM,
  ProductCode.OrbitL,
  ProductCode.SoftPos,
];

export const TERMINAL_PRODUCT_CODES: ReadonlyArray<ProductCode> = [
  ProductCode.OrbitM,
  ProductCode.OrbitL,
  ProductCode.SoftPos,
];

export const isTerminalProductCode = (code?: ProductCode | null) =>
  !!code && TERMINAL_PRODUCT_CODES.includes(code);

// Products whose PayPoints can be e-commerce gateways. OrbitS offers the Gateway type the same
// way OrbitM/OrbitL offer the Terminal type.
export const GATEWAY_PRODUCT_CODES: ReadonlyArray<ProductCode> = [
  ProductCode.OrbitS,
];

export const isGatewayProductCode = (code?: ProductCode | null) =>
  !!code && GATEWAY_PRODUCT_CODES.includes(code);
